import { render, staticRenderFns } from "./PaymentFormButton.vue?vue&type=template&id=5365c48c&"
import script from "./PaymentFormButton.vue?vue&type=script&lang=js&"
export * from "./PaymentFormButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports